import styled from 'styled-components';

import { pill } from '../../styles/mixins';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 25rem 1fr;
  gap: 3.6rem;
  align-items: flex-start;
  width: 100%;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const Sidebar = styled.aside`
  position: sticky;
  top: 2rem;

  @media (max-width: 860px) {
    display: none;
  }
`;

const Content = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

const ResultCount = styled.span`
  font-size: 1.35rem;
  color: var(--ink-soft);
  margin-right: auto;
`;

const FilterDrawerButton = styled.button`
  display: none;
  height: 3.8rem;
  align-items: center;
  gap: 0.7rem;
  padding: 0 1.6rem;
  border-radius: var(--r-pill);
  border: 1px solid var(--border-strong);
  background-color: var(--surface);
  color: var(--ink);
  font-size: 1.3rem;
  font-weight: 600;

  :hover {
    background-color: var(--surface-2);
  }

  @media (max-width: 860px) {
    display: inline-flex;
  }
`;

const ActiveChips = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  margin-bottom: 1.6rem;
  align-items: center;
`;

const ActiveChip = styled.span`
  ${pill}
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  color: var(--ink);
  font-size: 1.25rem;
  padding: 0.5rem 0.6rem 0.5rem 1.2rem;

  button {
    height: 1.8rem;
    width: 1.8rem;
    padding: 0;
    border: none;
    border-radius: 50%;
    background-color: var(--border-strong);
    color: var(--surface);
    display: flex;
    align-items: center;
    justify-content: center;

    :hover {
      background-color: var(--ink);
    }
  }
`;

const ClearAll = styled.button`
  height: auto;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--accent-deep);

  :hover {
    text-decoration: underline;
  }
`;

const ProjectsList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.2rem;
  width: 100%;
  min-height: 40vh;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.4rem;
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: var(--overlay);
  z-index: 60;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

const FilterDrawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(86vw, 34rem);
  background-color: var(--surface);
  border-left: 1px solid var(--border);
  z-index: 61;
  transform: ${({ isOpen }) =>
    isOpen ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform var(--dur-base) var(--ease-standard);
  display: flex;
  flex-direction: column;

  @media (min-width: 861px) {
    display: none;
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  border-bottom: 1px solid var(--border);

  strong {
    font-size: 1.7rem;
    color: var(--ink);
  }

  button {
    height: 3.6rem;
    width: 3.6rem;
    border: none;
    background: transparent;
    color: var(--ink-soft);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    :hover {
      background-color: var(--surface-2);
      color: var(--ink);
    }
  }
`;

const DrawerBody = styled.div`
  padding: 2rem;
  overflow-y: auto;
  flex: 1;
`;

export {
  ActiveChip,
  ActiveChips,
  ClearAll,
  Content,
  DrawerBody,
  DrawerHeader,
  FilterDrawer,
  FilterDrawerButton,
  Layout,
  Overlay,
  ProjectsList,
  ResultCount,
  Sidebar,
  Toolbar,
};
